import FormService from "../../services/FormService";
import FormInput from '../../components/FormInput';
import SelectPicker from '../../components/SelectPicker';
import Pagination from "../../components/Pagination";
import {ModelListSelect} from 'vue-search-select';

export default {
	components: {
		FormInput,
		SelectPicker,
		ModelListSelect,
		Pagination
	},
	data() {
		return {
			form: new FormService({
				name: null,
				email: null,
				password: null,
				type: null,
				status: null,
				user_role: null,
				phone: null,
				can_edit_user: false,
				username: null,
				permissions: []
			}),
			user_type: -1,
			user_types: [],
			user_roles: [],
			selected_user_roles: [],
			selected_user_name: '',
			selected_user_type: null,
			keyword: '',
			selected_user_id: '',
			modelList: [],
			modelStatuses: [],
			status: 10,
			editing_status: 0,
			can_edit_user: false,
			page: 1,
			links: {},
			permissions: []
		}
	},
	methods: {
		Create() {
			this.editing_status = 0;
			this.form.post('clients.create')
					.then(res => {
						console.log('stored', res);
						if (!res.errors) {
							$('#exampleModal').modal('hide');
							this.GetAll();
							this.$store.commit('successNotify');
						} else {
							alert(res.errors);
						}
					});
		},
		Read(id) {
			this.editing_status = 1;
			this.$api.get('clients.show', id)
					.then(res => {
						console.log(res);
						this.form.setData(res.data.client);
						this.form.permissions = [];
						res.data.permissions.map(x => {
							this.form.permissions.push(x.name);
						});
						this.form.password = '';
						$('#exampleModal').modal('show');
					});
		},
		Role(id) {
			this.$api.get('api-clients.show', id)
					.then(res => {
						this.form.setData(res.data);
						$('#roleModal').modal('show');
					});
		},
		Update() {
			this.form.put('clients.update', this.form.id)
					.then(res => {
						console.log(res);
						if (!res.errors) {
							$('#exampleModal').modal('hide');
							this.GetAll();
							this.$store.commit('successNotify');
						}
					});
		},
		Delete(id) {
			if (confirm('You are about to delete the record! \nAre you sure?')) {
				this.$api.delete('clients.delete', id)
						.then(res => {
							if (!res.errors) {
								this.GetAll();
								this.$store.commit('successNotify');
							}
						});
			}
		},
		GetAll() {
			this.$api.get('clients.index', {page: this.page, user_type: this.user_type, status: this.status})
					.then(res => {
						console.log(res);
						this.modelList = res.data.clients.data;
						this.user_types = res.data.types;
						this.modelStatuses = res.data.statuses;
						// this.can_edit_user = res.data.can_edit_user;
						// this.form.can_edit_user = res.data.can_edit_user;
						this.links = res.data.links;
					});
		},
		findType(type) {
			return this.user_types[type];
		},
		revealRoles(roles = null) {
			let user_roles = '';
			if (roles !== null) {
				let role_length = roles.length;
				let counter = 0;
				roles.forEach(item => {
					counter++;
					user_roles = user_roles + item.name + (role_length > counter ? ', ' : '');
				})
			}
			return user_roles;
		},
		filtered(list) {
			if (this.keyword) {
				// return list.filter((item) => {
				//     return (item.name && item.name.toLowerCase().includes(this.keyword))
				//         || (item.email && item.email.toLowerCase().includes(this.keyword));
				// });
			}
			return list;
		},
		getRoles(user_id) {
			this.$api.get('access-control.roles.index')
					.then(res => {
						this.user_roles = res.data;
						this.modelList.find((user, index) => {
							if (user.id === user_id) {
								user.roles.forEach((role, key) => {
									this.selected_user_roles.push(role.name);
								})
							}
						});
					});
		},
		giveRole(id, name, type) {
			this.selected_user_roles = [];
			this.getRoles(id);
			this.selected_user_id = id;
			this.selected_user_name = name;
			this.selected_user_type = type;
			$('#roleModal').modal('show');
		},
		attachRoles() {
			let postData = {};
			postData.user_id = this.selected_user_id;
			postData.roles = this.selected_user_roles;
			this.$api.post('api-clients.assign-role', postData).then(data => {
				if (data.status) {
					this.$store.commit('successNotify');
					$('#roleModal').modal('hide');
					this.selected_user_roles = null;
					this.selected_user_id = null;
					this.selected_user_type = null;
					this.selected_user_name = null;
					this.$router.go(0);
				}
			}).finally(() => {
				this.$router.go(0);
			});
		},
		getPermissions() {
			this.$api.get('clients.permissions')
					.then(data => {
						console.log('permissions', data);
						this.permissions = data.data;
					})
		}
	},
	created() {
		this.page = this.$route.params.page;
		this.GetAll();
		this.getPermissions();
	},
	mounted() {
		//this.GetAll();
		$('#exampleModal').on('hidden.bs.modal', (e) => {
			this.form.reset();
		})
	},
	computed: {
		type_list() {
			let types = [{id: -1, name: 'Все типы'}];
			Object.keys(this.user_types).forEach(e => {
				let type = {id: parseInt(e), name: this.user_types[e]};
				types.push(type)
			});
			return types;
		},
		user_status() {
			let types = [{id: -1, name: 'Все статусы'}];
			Object.keys(this.modelStatuses).forEach(e => {
				let type = {id: parseInt(e), name: this.modelStatuses[e]};
				types.push(type)
			});
			return types;
		}
	},
	watch: {
		user_type() {
			this.GetAll();
		},
		status() {
			this.GetAll();
		}
	},
	beforeRouteUpdate(to, from, next) {
		console.log("before route")
		let page = to.params.page;
		if (page) {
			this.page = page;
			this.GetAll();
		}
		next();
	},
}
